/* tslint:disable */
/* eslint-disable */
/**
 * comici-plus-api
 * # Comici Plus API v1  コンテンツプロバイダーがコンテンツの配信サイトを作成するために利用するAPIを提供します。 
 *
 * The version of the OpenAPI document: 1
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
/**
 * ユーザーが退会するリクエスト
 * @export
 * @interface WithdrawalRequestModel
 */
export interface WithdrawalRequestModel {
    /**
     * 退会の理由
     * * 0 : "読みたい作品がないから"
     * * 1 : "メールが多いから"
     * * 2 : "別のサイトを使うようになったから"
     * * 3 : "好きな作家が更新しなくなったから"
     * * 4 : "その他"
     * @type {Array<number>}
     * @memberof WithdrawalRequestModel
     */
    reasons?: Array<number>;
    /**
     * その他を選択した場合、記載した理由
     * @type {string}
     * @memberof WithdrawalRequestModel
     */
    message?: string;
}

/**
 * Check if a given object implements the WithdrawalRequestModel interface.
 */
export function instanceOfWithdrawalRequestModel(value: object): boolean {
    let isInstance = true;

    return isInstance;
}

export function WithdrawalRequestModelFromJSON(json: any): WithdrawalRequestModel {
    return WithdrawalRequestModelFromJSONTyped(json, false);
}

export function WithdrawalRequestModelFromJSONTyped(json: any, ignoreDiscriminator: boolean): WithdrawalRequestModel {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'reasons': !exists(json, 'reasons') ? undefined : json['reasons'],
        'message': !exists(json, 'message') ? undefined : json['message'],
    };
}

export function WithdrawalRequestModelToJSON(value?: WithdrawalRequestModel | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'reasons': value.reasons,
        'message': value.message,
    };
}

